import React from 'react';

/**
 * Loading - Consistent loading spinner component
 * Matches the UX pattern from PermitsPage
 */
export default function Loading({ message = 'Loading…', height = 'h-64' }) {
  return (
    <div className={`flex items-center justify-center ${height}`}>
      <div className="text-center">
        <div className="w-8 h-8 border-4 border-gray-700 border-t-blue-500 rounded-full animate-spin mx-auto mb-2" />
        <p className="text-gray-400 text-sm">{message}</p>
      </div>
    </div>
  );
}
